var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"back-to-top-div",attrs:{"title":"回到顶部"},on:{"click":_vm.do_back_to_top}},[_c('i',{staticClass:"com-iconfont iconjiantou i-back-top"})])}
var staticRenderFns = []

export { render, staticRenderFns }